// Define variables
jQuery(document).ready(function ($) {
    var widget = $('.alert-widget');
    var widgetButton = $('.alert-widget__close');
    var cookie = getCookie('bemoonAlertCookie');

    // Set cookie expiry date
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return "";
    }
    
    // Check if cookie was already set
    if (cookie == '') {
        $(widget).fadeIn();
    } else {
        $(widget).hide();
    }
        
    // Hide widget on button click
    $(widgetButton).click(function(){
        setCookie('bemoonAlertCookie', 'hide', 1);
        $(widget).fadeOut();
    });
});